




















import {
  ref,
  useContext,
  useRoute,
  defineComponent,
  useFetch
} from "@nuxtjs/composition-api";
import { merge } from "lodash-es";
import { useCache, CacheTagPrefix } from "@vue-storefront/cache";
import { SfLoader } from "@storefront-ui/vue";
import { useProduct } from "~/modules/catalog/product/composables/useProduct";
import { getMetaInfo } from "~/helpers/getMetaInfo";
import { usePageStore } from "~/stores/page";
import { useApi } from "~/composables";
import LoadWhenVisible from "~/components/utils/LoadWhenVisible.vue";
import type { Product } from "~/utils/types/Product"
import type { ProductDetailsQuery } from "~/modules/GraphQL/types";
import getProductExtendedDatas from "~/modules/catalog/product/queries/mbooks-getProductExtendedDatas.gql";
import { useProductGallery } from "~/modules/catalog/product/composables/useProductGallery";
import ProductGallerySlider from "~/components/mbooks/ProductGallerySlider.vue";
import ProductNav from "~/components/mbooks/ProductNav.vue";
import ConfigurableProductBody from '~/components/mbooks/Configurable/ConfigurableProductBody.vue';
import BundleProductBody from '~/components/mbooks/Bundle/BundleProductBody.vue';
import {IN_STOCK, CONFIGURABLE_TYPENAME, BUNDLE_TYPENAME} from '~/utils/constants/product';
import TruncatedText from '~/components/TruncatedText.vue';
import ProductEstratto from "~/components/mbooks/Configurable/ProductEstratto.vue";
import useLoader from "~/composables/useLoader";
import { getBaseSearchQuery }from '~/modules/catalog/product/helpers/queryHelpers';
export default defineComponent({
  name: "ProductPage",
  components: {
    SfLoader,
    LoadWhenVisible,
    ProductGallerySlider,
    ProductNav,
    TruncatedText,
    ConfigurableProductBody,
    BundleProductBody,
    ProductEstratto
  },
  //transition: "fade",
  setup() {
    const { setIsLoading } = useLoader();
    const { routeData } = usePageStore();
    const { query } = useApi();
    const product = ref<Product | null>(null);
    let isAvailable = ref<Boolean>(false);
    const { addTags } = useCache();
    const route = useRoute();
    const { getProductDetails, loading } = useProduct();
    const { error: nuxtError } = useContext();
    const isConfigurable = ref<Boolean>(false);
    const datasReady = ref<Boolean>(false);
    const isBundle = ref<Boolean>(false);

    const fetchProductBaseData = async (searchQuery = getBaseSearchQuery(routeData.sku, route.value.query)) => {
      const result = await getProductDetails({
        ...searchQuery,
      });

      product.value = merge(
        {},
        product.value,
        (result.items[0] as Product) ?? null
      );
      isConfigurable.value = product.value.__typename == CONFIGURABLE_TYPENAME;
      isBundle.value = product.value.__typename == BUNDLE_TYPENAME;
    };

    const fetchProductExtendedData = async (
      searchQuery = getBaseSearchQuery(routeData.sku, route.value.query)
    ) => {
      const { data } = await query<ProductDetailsQuery>(
        getProductExtendedDatas,
        searchQuery
      );

      product.value = merge(
        {},
        product.value,
        data.products?.items?.[0] as Product
      );
      isAvailable.value = product.value.stock_status == IN_STOCK;
      datasReady.value=true;
    };

    useFetch(async () => {
      setIsLoading(true);
      await fetchProductBaseData();
      await fetchProductExtendedData();
      setIsLoading(false);
 
      if (Boolean(product?.value?.sku) === false){
        nuxtError({ statusCode: 404 });
      }

      const tags = [
        {
          prefix: CacheTagPrefix.View,
          value: `product-${routeData.sku}`,
        },
      ];

      const productTags = [
        {
          prefix: CacheTagPrefix.Product,
          value: product.value.uid,
        },
      ];

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      addTags([...tags, ...productTags]);

    });

    const { productGallery } = useProductGallery(product);

    return {
      loading,
      product,
      isConfigurable,
      isBundle,
      fetchProduct: fetchProductExtendedData,
      productGallery,
      isAvailable,
      datasReady
    };
  },
  head() {
    return getMetaInfo(this.product);
  }
});
